export default __webpack_public_path__ + "static/media/4-A.DOC.app.d6fb979f.png";